
//通用
import { Data as AuthContent } from '../authentication/index'
import { Data as ChangeLogContent } from '../changelog/index'
import { Data as OtherContent } from '../listenKey/index'

//共用
import { List as SocketContent } from '../spot/websocket/index'
import { Data as BasicContent } from '../spot/api/basic/index'
import { Data as AccountContent } from '../spot/api/account/index'
import { Data as WalletContent } from '../spot/api/wallet/index'

import Introduce from './1_introduce.json'
import { Data as PermissionContent } from './api/permission/index'
import { Data as SubAccount } from './api/subAccount/index'



let aaa = JSON.stringify(OtherContent)
aaa = aaa.replaceAll("/market/<listenKey>", "/market?listenKey==")
aaa = aaa.replaceAll("wss://open-api-ws.bingx.com/market?listenKey=", "wss://open-api-ws.bingx.com/market?listenKey=a8ea75681542e66f1a50a1616dd06ed77dab61baa0c296bca03a9b13ee5f2dd7")

const ROOT_MODULE = "zh-tw/common"
import { Data as QandAContent } from '../q&a/index'
const QandA = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/q&a`,
  "name": "常見問題",
  "content": QandAContent
}
export const Socket = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/socket`,
  "name": "Socket 文檔",
  "children": SocketContent
}
const SubAccountContent = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/sub-account`,
  "name": "子賬戶管理",
  "content": SubAccount
}

const ChangeLog = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/changelog`,
  "name": "變更日誌",
  "content": ChangeLogContent
}

const Authentication = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/authentication.html`,
  "name": "簽名認證",
  "content": AuthContent
}
const Basic = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/base-info.html`,
  "name": "基礎信息",
  "content": BasicContent
}
const Account = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/account-api.html`,
  "name": "賬戶資產",
  "content": AccountContent
}
const Wallet = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/wallet-api.html`,
  "name": "錢包充提",
  "content": WalletContent
}
// const Permission = {
//   "module": ROOT_MODULE,
//   "path": `/${ROOT_MODULE}/permission-interface.html`,
//   "name": "權限接口",
//   "content": PermissionContent
// }
const Auth = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/authentication-interface.html`,
  "name": "鑒權服務",
  "content": JSON.parse(aaa)
}


export const commonConfig = [
  Introduce,
  ChangeLog,
  QandA,
  Basic,
  Authentication,
  // Permission,
  Account,
  Wallet,
  SubAccountContent,
  Auth,
]


// WEBPACK FOOTER //
// ./src/config/zh-tw/common/index.js